import * as React from 'react';
import { Select, MenuItem, FormControl, InputLabel, Box } from '@mui/material';
import { useListContext } from 'react-admin';
import { useConfigurationContext } from '@app/root/ConfigurationContext';

export const MediaListFilter = () => {
    const { resourceTypeLabels } = useConfigurationContext();
    const { filterValues, setFilters } = useListContext();

    const handleTypeChange = (event: any) => {
        const newFilters = { ...filterValues };
        if (event.target.value === 'all') {
            delete newFilters.type;
        } else {
            newFilters.type = event.target.value;
        }
        setFilters(newFilters);
    };

    const currentType = filterValues?.type || 'all';

    return (
        <Box>
            <FormControl size="small" fullWidth>
                <InputLabel>Media Type</InputLabel>
                <Select
                    value={currentType}
                    label="Media Type"
                    onChange={handleTypeChange}
                >
                    <MenuItem value="all">All Types</MenuItem>
                    {resourceTypeLabels.map(type => (
                        <MenuItem key={type.value} value={type.value}>
                            {type.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};
